import { atom } from 'recoil'

export let toast_state = atom<{
  message: string
  color?: string
} | null>({
  key: 'toast_state',
  default: null,
})
